const QUERY_KEY = {
  MANGA_MANAGEMENT: "mangaManagement",
  CHAPTER_MANAGEMENT: "chapterManagement",
};
export default QUERY_KEY;
